import {useDispatch} from 'react-redux'
import Table from 'rsuite/Table'
import Toggle from 'rsuite/Toggle'
import {StateParamsModel} from 'src/app/modules/common/Model'
import checkBackendSetting from 'src/app/modules/common/checkBackendSetting'
import * as leadFormRedux from '../index'

// Legacy SBL product lead inbox: page URL, IP and a Pending / Reviewed status. Shown only when the backend setting
// leadFormContactTracking is '1'. Row data needs pageUrl, ipAddress and isContacted.
export const useContactTracking = (
  params: StateParamsModel,
  setParams: (params: StateParamsModel) => void
) => {
  const dispatch = useDispatch()
  const enabled = checkBackendSetting('leadFormContactTracking')
  if (!enabled) return {columns: [], filter: null}

  const Cell = Table.Cell
  const columns = [
    {
      label: 'Page URL',
      dataKey: 'pageUrl',
      flexGrow: 1,
      cell: (
        <Cell>
          {(rowData) =>
            // submitted by the public form: link only absolute http(s) URLs, never javascript: / data:
            /^https?:\/\//i.test(rowData?.pageUrl || '') ? (
              <a href={rowData.pageUrl} target='_blank' rel='noopener noreferrer'>
                {rowData.pageUrl}
              </a>
            ) : (
              rowData?.pageUrl || '-'
            )
          }
        </Cell>
      ),
      sortable: false,
    },
    {
      label: 'IP Address',
      dataKey: 'ipAddress',
      width: 130,
      cell: <Cell>{(rowData) => rowData?.ipAddress || '-'}</Cell>,
      sortable: false,
    },
    {
      label: 'Contacted',
      dataKey: 'isContacted',
      width: 100,
      cell: (
        <Cell>
          {(rowData) => (
            <Toggle
              size='sm'
              checked={!!rowData?.isContacted}
              onChange={(checked) =>
                dispatch(leadFormRedux.actions.setLeadContacted(rowData.id, checked, params))
              }
            />
          )}
        </Cell>
      ),
      sortable: false,
    },
  ]

  const filter = (
    <div className='d-flex justify-content-end mb-3'>
      <select
        className='form-select form-select-sm w-auto'
        aria-label='Contact status'
        value={params.isContacted ?? ''}
        onChange={(e) => setParams({...params, page: 1, isContacted: e.target.value || undefined})}
      >
        <option value=''>All leads</option>
        <option value='0'>Pending</option>
        <option value='1'>Contacted</option>
      </select>
    </div>
  )

  return {columns, filter}
}
